import { render, staticRenderFns } from "./top-setting.vue?vue&type=template&id=1273877a&scoped=true&"
import script from "./top-setting.vue?vue&type=script&lang=js&"
export * from "./top-setting.vue?vue&type=script&lang=js&"
import style0 from "./top-setting.vue?vue&type=style&index=0&id=1273877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273877a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1273877a')) {
      api.createRecord('1273877a', component.options)
    } else {
      api.reload('1273877a', component.options)
    }
    module.hot.accept("./top-setting.vue?vue&type=template&id=1273877a&scoped=true&", function () {
      api.rerender('1273877a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-setting.vue"
export default component.exports